import "regenerator-runtime/runtime";

import React, { Component } from "react";

// import InfiniteList from "react-infinite-scroll-list";
import { InfiniteScroll } from "react-simple-infinite-scroll";

import InfiniteScrollSimple from "./InfiniteScrollSimple.js";

import SectionItem from "./SectionItem.js";

class SectionList extends Component {
  constructor(props) {
    super(props);

    console.log("items: ", props);

    let items;
    props.initialItems
      ? (items = JSON.parse(props.initialItems))
      : (items = []);

    let isEndReached;
    if (items[0] && items[0].is_end_reached) {
      isEndReached = items[0].is_end_reached;
    } else {
      isEndReached = false;
    }

    this.state = {
      items: items,
      isLoading: false,
      isEndReached: items[0].is_end_reached
    };

    this.onReachThreshold = this.onReachThreshold.bind(this);
    this.renderList = this.renderList.bind(this);
  }

  loadMorePath = () => {
    let location = window.location;
    let url = location.protocol + "//" + location.host + location.pathname;
    let qs = location.search.split("?")[1];
    url = `${url}/load_more?page=${this.state.items.length}`;
    if (qs) {
      url = url + "&" + qs;
    }
    return url;
  };

  async onReachThreshold() {
    console.log("onReachThreshold");

    this.setState({ isLoading: true });

    console.log("loading...");

    let response = await fetch(this.loadMorePath());

    let data = await response.json();
    console.log("data: ", data);

    this.setState(({ items }) => {
      return {
        isLoading: false,
        items: items.concat(data),
        isEndReached: data.is_end_reached
      };
    });

    this.afterAddItems();
  }

  afterAddItems = () => {
    console.log("afterAddItems");
  };

  // renderItem = item => {
  //   return (
  //     <div
  //       className={this.props.itemClassName}
  //       key={item.id}
  //       dangerouslySetInnerHTML={{ __html: item.html }}
  //     />
  //   );
  // };

  renderItem = item => {
    return (
      <SectionItem
        itemClassName={this.props.itemClassName}
        key={item.id}
        item={item}
      />
    );
  };

  renderItems = () => {
    return this.state.items.map(item => this.renderItem(item));
  };

  renderList(obj) {
    let sentinel = obj.sentinel;

    console.log("renderList: ", sentinel);
    return (
      <div className={this.props.className}>
        {this.renderItems()}
        {sentinel}
      </div>
    );
  }

  render() {
    return (
      <InfiniteScrollSimple
        throttle={100}
        threshold={2000}
        isLoading={this.state.isLoading}
        hasMore={!this.state.isEndReached}
        onLoadMore={this.onReachThreshold}
        render={this.renderList}
      />
    );
  }
}

export default SectionList;
